"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lbFlightAccordionDetailsSx = exports.lbAccordionDetailsSx = exports.lbFlightAccordionSummarySx = exports.lbAccordionSummarySx = exports.lbFlightAccordionSx = exports.lbAccordionSx = void 0;
function accordionRoot(theme, shadowLevel, mb) {
    return {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        mb,
        borderRadius: 1,
        boxShadow: theme.shadows[shadowLevel],
        "&:before": { display: "none" },
        backgroundColor: "transparent",
        padding: 0,
        boxSizing: "border-box",
    };
}
/** Division-level accordion: compact height, primary header, elevation when stacked. */
const lbAccordionSx = (theme) => accordionRoot(theme, 3, 0.75);
exports.lbAccordionSx = lbAccordionSx;
/** Nested flight accordion: inset, slightly lighter shadow. */
const lbFlightAccordionSx = (theme) => ({
    ...accordionRoot(theme, 2, 0.5),
    width: 'calc(100% - 8px)',
    maxWidth: 'calc(100% - 8px)',
    ml: 1,
});
exports.lbFlightAccordionSx = lbFlightAccordionSx;
const summaryBase = (theme, minH) => ({
    backgroundColor: "sepia.background",
    borderBottom: `1px solid ${theme.palette.sepia?.light ?? 'rgba(0,0,0,0.1)'}`,
    borderRadius: 1,
    minHeight: minH,
    py: 0,
    px: 1,
    "& .MuiAccordionSummary-content": {
        margin: theme.spacing(0.25, 0),
        alignItems: "center",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
        padding: theme.spacing(0.25),
    },
});
const lbAccordionSummarySx = (theme) => summaryBase(theme, 28);
exports.lbAccordionSummarySx = lbAccordionSummarySx;
const lbFlightAccordionSummarySx = (theme) => summaryBase(theme, 26);
exports.lbFlightAccordionSummarySx = lbFlightAccordionSummarySx;
exports.lbAccordionDetailsSx = {
    px: 0.75,
    py: 0.25,
    minWidth: 0,
    overflow: 'hidden',
};
exports.lbFlightAccordionDetailsSx = {
    px: 0.75,
    py: 0.25,
    minWidth: 0,
    overflow: 'hidden',
};
